const selectors = {
  accordionToggle: 'data-accordion-toggle',
  accordionWrappper: '[data-accordion]',
  block: 'data-accordion-block',
  focusable: 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])',
};

const classes = {
  isVisible: 'is-visible',
};

let sections = {};

class Accordion {
  constructor(el) {
    this.accordion = el;
    this.wrapper = el.closest(selectors.wrapper);
    this.key = this.accordion.id;
    const btnSelector = `[${selectors.accordionToggle}='${this.key}']`;
    this.trigger = document.querySelector(btnSelector);
    this.children = this.accordion.querySelectorAll(':scope > *');

    this.trigger.setAttribute('aria-haspopup', true);
    this.trigger.setAttribute('aria-expanded', false);
    this.trigger.setAttribute('aria-controls', this.key);

    this.clickEvents();
    this.staggerChildAnimations();
  }
  clickEvents() {
    this.trigger.addEventListener('click', function() {
      this.toggleState();
    }.bind(this));
  }
  keyboardEvents() {
    this.trigger.addEventListener('keyup', function(evt) {
      if (evt.which !== window.theme.keyboardKeys.SPACE) { return; }
      this.showAccordion();
    }.bind(this));
    this.accordion.addEventListener('keyup', function(evt) {
      if (evt.which !== window.theme.keyboardKeys.ESCAPE) { return; }
      this.hideAccordion();
      this.buttons[0].focus();
    }.bind(this));
  }
  staggerChildAnimations() {
    this.children.forEach((child, index) => {
      child.style.transitionDelay = `${((index * 80) + 10)}ms`;
    });
  }
  toggleState() {
    if (this.accordion.classList.contains(classes.isVisible)) {
      this.hideAccordion();
    } else {
      this.showAccordion();
    }
  }
  hideAccordion() {
    this.accordion.classList.remove(classes.isVisible);
    this.trigger.classList.remove(classes.isVisible);
  }
  showAccordion() {
    this.accordion.classList.add(classes.isVisible);
    this.trigger.classList.add(classes.isVisible);
  }
  onBlockSelect(evt) {
    console.log(evt);
    if (this.accordion.contains(evt.target)) {
      this.showAccordion();
    }
  }
  onBlockDeselect(evt) {
    if (this.accordion.contains(evt.target)) {
      this.hideAccordion();
    }
  }
}

const accordion = {
  onLoad() {
    sections[this.id] = [];
    const els = this.container.querySelectorAll(selectors.accordionWrappper);
    els.forEach(el => {
      sections[this.id].push(new Accordion(el));
    });
  },
  onUnload: function() {
    sections[this.id].forEach(el => {
      if (typeof el.unload === 'function') {
        el.unload();
      }
    });
  },
  onBlockSelect(evt) {
    sections[this.id].forEach(el => {
      if (typeof el.onBlockSelect === 'function') {
        el.onBlockSelect(evt);
      }
    });
  },
  onBlockDeselect(evt) {
    sections[this.id].forEach(el => {
      if (typeof el.onBlockDeselect === 'function') {
        el.onBlockDeselect(evt);
      }
    });
  },
};

export default accordion;
